// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menuHeader[data-v-65984728]{padding:.5rem 0;position:absolute;left:0;width:100%;height:50px;border-bottom:2px solid #6768a8}.menuHeader p[data-v-65984728]{color:#4a669e;text-align:center;font-weight:700}.menuRow[data-v-65984728]{padding:1rem;box-sizing:border-box;text-align:left;height:3.8rem;width:100%}", ""]);
// Exports
module.exports = exports;
